 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"aboutus":"aboutus","addAward~addCourse~addEvent~addPost~addStudent~addUser~awardDetails~courseDetails~editAward~editCour~3f93d1bc":"addAward~addCourse~addEvent~addPost~addStudent~addUser~awardDetails~courseDetails~editAward~editCour~3f93d1bc","addAward":"addAward","addCourse~addEvent~addPost~editCourse~editEvent~editPost":"addCourse~addEvent~addPost~editCourse~editEvent~editPost","addEvent~addPost~editEvent~editPost":"addEvent~addPost~editEvent~editPost","addEvent":"addEvent","addPost":"addPost","editEvent":"editEvent","editPost":"editPost","addCourse~addStudent~datatablevue~editCourse~editStudent~giveAward~marks":"addCourse~addStudent~datatablevue~editCourse~editStudent~giveAward~marks","addCourse":"addCourse","editCourse":"editCourse","addStudent":"addStudent","datatablevue~giveAward":"datatablevue~giveAward","giveAward":"giveAward","editStudent":"editStudent","addUser":"addUser","awardDetails":"awardDetails","courseDetails":"courseDetails","editAward":"editAward","eventDetails":"eventDetails","galleryDetails":"galleryDetails","galleryHome":"galleryHome","postDetails":"postDetails","studentDetails":"studentDetails","marks":"marks","articlelist":"articlelist","awardWelcome":"awardWelcome","awardlist":"awardlist","awards":"awards","contactus":"contactus","courseWelcome":"courseWelcome","courses":"courses","editUser":"editUser","eventList":"eventList","eventWelcome":"eventWelcome","events":"events","exam":"exam","galleryOverview":"galleryOverview","gallerylist":"gallerylist","modesoflearning":"modesoflearning","postList":"postList","postWelcome":"postWelcome","posts":"posts","students":"students","tagline":"tagline","testimonal":"testimonal","userDetails":"userDetails","users":"users","datatablevue":"datatablevue"}[chunkId]||chunkId) + "." + {"aboutus":"31de1388","addAward~addCourse~addEvent~addPost~addStudent~addUser~awardDetails~courseDetails~editAward~editCour~3f93d1bc":"817a9c84","addAward":"af10fb0f","addCourse~addEvent~addPost~editCourse~editEvent~editPost":"b772827b","addEvent~addPost~editEvent~editPost":"7a83466d","addEvent":"e6338c3f","addPost":"977c8e93","editEvent":"840a3b23","editPost":"33774ab3","addCourse~addStudent~datatablevue~editCourse~editStudent~giveAward~marks":"ed24d949","addCourse":"1b3fa52d","editCourse":"becf0de4","addStudent":"a36b187a","datatablevue~giveAward":"dda45e3d","giveAward":"926b15bb","editStudent":"3d434823","addUser":"1c294784","awardDetails":"8f355c27","courseDetails":"e08f91c4","editAward":"20230b43","eventDetails":"1c6c91d4","galleryDetails":"a5ab03ef","galleryHome":"961533df","postDetails":"d57fcea3","studentDetails":"6adca780","marks":"2ce6816b","articlelist":"8bca3983","awardWelcome":"6afe7e0a","awardlist":"e628e927","awards":"c9fca83b","chunk-0ab041ff":"c9a49b69","chunk-460d2ee6":"20ee6c38","contactus":"911da161","courseWelcome":"6183146c","courses":"f4fcc094","editUser":"5e9422c6","eventList":"1c5389f3","eventWelcome":"15a78bba","events":"7e53ecc7","exam":"9100bcfe","galleryOverview":"baeaab4e","gallerylist":"cbe9f6e3","modesoflearning":"2baf7910","postList":"deda560d","postWelcome":"c01d241b","posts":"2e52eae2","students":"15386bec","tagline":"56a5ec59","testimonal":"c5d26030","userDetails":"fc047c01","users":"ebe38800","datatablevue":"08986272"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"aboutus":1,"addAward":1,"addCourse~addEvent~addPost~editCourse~editEvent~editPost":1,"addEvent~addPost~editEvent~editPost":1,"addEvent":1,"editEvent":1,"addCourse~addStudent~datatablevue~editCourse~editStudent~giveAward~marks":1,"addCourse":1,"editCourse":1,"addStudent":1,"datatablevue~giveAward":1,"giveAward":1,"editStudent":1,"addUser":1,"awardDetails":1,"courseDetails":1,"editAward":1,"eventDetails":1,"galleryDetails":1,"galleryHome":1,"postDetails":1,"studentDetails":1,"marks":1,"articlelist":1,"awardWelcome":1,"awardlist":1,"chunk-0ab041ff":1,"chunk-460d2ee6":1,"contactus":1,"courseWelcome":1,"eventList":1,"eventWelcome":1,"exam":1,"galleryOverview":1,"gallerylist":1,"modesoflearning":1,"postList":1,"postWelcome":1,"tagline":1,"testimonal":1,"userDetails":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"aboutus":"aboutus","addAward~addCourse~addEvent~addPost~addStudent~addUser~awardDetails~courseDetails~editAward~editCour~3f93d1bc":"addAward~addCourse~addEvent~addPost~addStudent~addUser~awardDetails~courseDetails~editAward~editCour~3f93d1bc","addAward":"addAward","addCourse~addEvent~addPost~editCourse~editEvent~editPost":"addCourse~addEvent~addPost~editCourse~editEvent~editPost","addEvent~addPost~editEvent~editPost":"addEvent~addPost~editEvent~editPost","addEvent":"addEvent","addPost":"addPost","editEvent":"editEvent","editPost":"editPost","addCourse~addStudent~datatablevue~editCourse~editStudent~giveAward~marks":"addCourse~addStudent~datatablevue~editCourse~editStudent~giveAward~marks","addCourse":"addCourse","editCourse":"editCourse","addStudent":"addStudent","datatablevue~giveAward":"datatablevue~giveAward","giveAward":"giveAward","editStudent":"editStudent","addUser":"addUser","awardDetails":"awardDetails","courseDetails":"courseDetails","editAward":"editAward","eventDetails":"eventDetails","galleryDetails":"galleryDetails","galleryHome":"galleryHome","postDetails":"postDetails","studentDetails":"studentDetails","marks":"marks","articlelist":"articlelist","awardWelcome":"awardWelcome","awardlist":"awardlist","awards":"awards","contactus":"contactus","courseWelcome":"courseWelcome","courses":"courses","editUser":"editUser","eventList":"eventList","eventWelcome":"eventWelcome","events":"events","exam":"exam","galleryOverview":"galleryOverview","gallerylist":"gallerylist","modesoflearning":"modesoflearning","postList":"postList","postWelcome":"postWelcome","posts":"posts","students":"students","tagline":"tagline","testimonal":"testimonal","userDetails":"userDetails","users":"users","datatablevue":"datatablevue"}[chunkId]||chunkId) + "." + {"aboutus":"c9b62b84","addAward~addCourse~addEvent~addPost~addStudent~addUser~awardDetails~courseDetails~editAward~editCour~3f93d1bc":"31d6cfe0","addAward":"de4cbd29","addCourse~addEvent~addPost~editCourse~editEvent~editPost":"577a778b","addEvent~addPost~editEvent~editPost":"8e46331b","addEvent":"62d4dde5","addPost":"31d6cfe0","editEvent":"62d4dde5","editPost":"31d6cfe0","addCourse~addStudent~datatablevue~editCourse~editStudent~giveAward~marks":"bc466961","addCourse":"5026fa31","editCourse":"5026fa31","addStudent":"577a778b","datatablevue~giveAward":"1d097a8a","giveAward":"076ea886","editStudent":"577a778b","addUser":"a8934370","awardDetails":"a4f0ed9a","courseDetails":"a4f0ed9a","editAward":"de4cbd29","eventDetails":"a4f0ed9a","galleryDetails":"099088ed","galleryHome":"017f50e4","postDetails":"a4f0ed9a","studentDetails":"6a0c2d83","marks":"9dcafde0","articlelist":"5ec3afa0","awardWelcome":"497763ea","awardlist":"8f617109","awards":"31d6cfe0","chunk-0ab041ff":"026f886d","chunk-460d2ee6":"4a0c439e","contactus":"a3f5f701","courseWelcome":"17ae1f9a","courses":"31d6cfe0","editUser":"31d6cfe0","eventList":"398a2686","eventWelcome":"22f41fe9","events":"31d6cfe0","exam":"3ead7e59","galleryOverview":"73a5dbc0","gallerylist":"9ecce76d","modesoflearning":"64010c05","postList":"93295ba4","postWelcome":"0620d19a","posts":"31d6cfe0","students":"31d6cfe0","tagline":"82508cb8","testimonal":"56890a93","userDetails":"a4f0ed9a","users":"31d6cfe0","datatablevue":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
